module.exports = __webpack_public_path__ + "static/media/bedroom.951237d8.svg";